import { format } from 'date-fns';
import { Image } from 'expo-image';
import { Pressable, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';

import { Replace } from '../icons/replace';
import { TrashFill } from '../icons/trash-fill';

interface FileItemProps {
  imageUrl: string;
  imageFileName: string;
  onDelete: () => void;
  onReplace?: () => void;
}

export default function FileItem({
  imageUrl,
  imageFileName,
  onDelete,
  onReplace,
}: FileItemProps) {
  const { theme } = useStyles();

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <View
          style={{
            backgroundColor: theme.colors.card.default.backgroundColor,
            width: 60,
            height: 60,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 8,
          }}
        >
          <Image
            source={{ uri: imageUrl }}
            style={{ width: 56, height: 56 }}
            contentFit="contain"
          />
        </View>

        <View>
          <Text type="bodyRegular" style={{ width: 170 }}>
            {imageFileName}
          </Text>
          <Text type="caption1" style={{ color: theme.colors.text.secondary }}>
            {format(new Date(), 'MMM dd, yyyy')}
          </Text>
        </View>
      </View>

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 8,
        }}
      >
        {onReplace ? (
          <Pressable
            onPress={onReplace}
            style={({ pressed }) => [
              {
                width: 40,
                height: 40,
                alignItems: 'center',
                justifyContent: 'center',
                opacity: pressed ? 0.5 : 1,
                backgroundColor: theme.colors.button.secondary.default.fill,
                borderRadius: 100,
                borderColor: theme.colors.button.secondary.default.border,
                borderWidth: 1,
                paddingTop: 8,
                paddingBottom: 8,
                paddingLeft: 16,
                paddingRight: 16,
              },
            ]}
          >
            <Icon
              type="naked"
              icon={<Replace />}
              fillColor={theme.colors.icon.color}
              width={16}
              height={16}
            />
          </Pressable>
        ) : null}

        <Pressable
          onPress={onDelete}
          style={({ pressed }) => [
            {
              width: 40,
              height: 40,
              alignItems: 'center',
              justifyContent: 'center',
              opacity: pressed ? 0.5 : 1,
              backgroundColor: theme.colors.button.secondary.default.fill,
              borderRadius: 100,
              borderColor: theme.colors.button.secondary.default.border,
              borderWidth: 1,
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 16,
              paddingRight: 16,
            },
          ]}
        >
          <Icon
            type="naked"
            icon={<TrashFill />}
            fillColor={theme.colors.icon.color}
            width={16}
            height={16}
          />
        </Pressable>
      </View>
    </View>
  );
}
